export const ExternalUrl = ({ children }: { children?: unknown }) =>
  typeof children === 'string' ? (
    <a href={/\/\//.test(children) ? children : `//${children}`} target="_blank" rel="noreferrer">
      {children}
    </a>
  ) : (
    <></>
  );
